
















import { Component, Vue, Prop, Provide } from 'vue-property-decorator'

@Component
export default class CmsPreview extends Vue {
  @Prop() public url!: string
  public get base() {
    if (this.url) {
      if (this.url.indexOf('https://') > -1) {
        return 'https://vip.ow365.cn?i=22595&ssl=1&del=1&furl='
      }
    }
    return 'https://vip.ow365.cn?i=22595&del=1&furl='
  }
  public judgePics(item) {
    let whiteList = ['.jpg', '.png', '.gif', '.jpeg', '.svg', ';base64']
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
}
